module.exports = __webpack_public_path__ + "img/86e99664a08a4b69bc3da83d3e2befb7.b2202761.png";